module.exports = __webpack_public_path__ + "static/img/ic_empty_503@3x.34a45427.png";